var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIconSmallGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.026 0L7 5.12692L1.974 0L0 2.01364L5.026 7.14056L0 12.2675L1.974 14.2811L7 9.1542L12.026 14.2811L14 12.2675L8.974 7.14056L14 2.01364L12.026 0Z",
    fill: "#98A2B3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIconSmallGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeIconSmallGray.ab0f6d9d3931ed4c2d16b71c8d5e2435.svg";